/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './activity/activity.js';
import './audit/audit.js';
import './log.tpl.html';
import './toolbar/toolbar.js';

angular
  .module('log', ['ui.router', 'log.activity', 'log.audit', 'log.toolbar', 'ngAnimate', 'sbsf.constants'])
  .constant('ACTIVITY_VIEWS', {
    ACTIVITY: 'activity',
    AUDIT: 'audit'
  })
  // This defines the main abstract log view that is shared across all
  // subviews.
  .config([
    '$stateProvider',
    'VIEW_STATES',
    function ($stateProvider, VIEW_STATES) {
      $stateProvider
        .state(VIEW_STATES.LOG, {
          abstract: true,
          resolve: {
            latestBackup: [
              'batchUtils',
              function (batchUtils) {
                return batchUtils.getLatestBackup();
              }
            ]
          },
          views: {
            content: {
              templateUrl: 'log/log.tpl.html',
              controller: 'LogCtrl'
            }
          }
        })
        // The views that are rendered in the log view.
        .state(VIEW_STATES.LOG_HOME, {
          url: '/log',
          resolve: {
            activities: [
              'pagingUtils',
              function (pagingUtils) {
                return pagingUtils.getActivities().then(function () {
                  var activities = {
                    totalItems: pagingUtils.pagingInfo.totalItems,
                    items: pagingUtils.pagingInfo.items
                  };
                  return activities;
                });
              }
            ]
          },
          views: {
            activity: {
              templateUrl: 'log/activity/activity.tpl.html'
            }
          }
        });
    }
  ])
  /**
   * Controller for the abstract log view.  It only contains values that are
   * inherited and utilized by it's implementing views.
   */
  .controller('LogCtrl', [
    '$scope',
    'progressFactory',
    'PROGRESS_ACTIONS',
    'ACTIVITY_VIEWS',
    function ($scope, progressFactory, PROGRESS_ACTIONS, ACTIVITY_VIEWS) {
      // Make a local reference to the progress ACTIONS constant.
      $scope.ACTIONS = PROGRESS_ACTIONS;
      $scope.ACTIVITY_VIEWS = ACTIVITY_VIEWS;
      $scope.logView = ACTIVITY_VIEWS.ACTIVITY;
      $scope.initialLoad = true;

      /**
       * Show the passed view.
       * @param {string} view - The view to display.  Must be one of the views defined in the logViews array.
       */
      $scope.showView = function (view) {
        if (view === ACTIVITY_VIEWS.AUDIT) {
          // Lazy load the audit view
          if ($scope.initialLoad) {
            $scope.initialLoad = false;
            $scope.$broadcast('updateAuditEvent');
          }
        }
        $scope.logView = view;
      };
    }
  ]);
